import useTranslation from '../hooks/useTranslation';
import React from 'react';
import styled from 'styled-components';
import { ValidatedDropDownField } from './Form/ValidatedDropDownField';
import { ValidatedInputField } from './Form/ValidatedInputField';
import cssIngka from '@ingka/variables/colours-css';

interface RenderFieldsProps {
  // eslint-disable-next-line
  fields: any[];
  isSubmitBtnClicked: boolean;
  divideAfter?: string;
}

const StyledDivider = styled.hr`
  width: 55%;
  height: 0px;
  margin: 0 auto;
  border-block-start: 1px solid ${cssIngka.colourNeutral3};
`;

export const RenderFields: React.FC<RenderFieldsProps> = ({
  fields,
  isSubmitBtnClicked,
  divideAfter,
}) => {
  const { t } = useTranslation();
  const renderFields = fields
    .filter((x) => x.shouldRender)
    .sort((a, b) => {
      return a.order - b.order;
    })
    .map(
      ({
        id,
        label,
        value,
        type = 'text',
        onChange,
        onBlur,
        validatedField,
        $fullwidth,
        options,
        req,
        disabled = false,
        autocomplete,
        render,
      }) => {
        if (render) {
          return <React.Fragment key={id}>{render}</React.Fragment>;
        }

        if (['dropdown', 'dropdown-with-value'].includes(type)) {
          let chooseAnOption = {
            name: t('orderForm.chooseAnOption'),
            value: '',
          };

          if (!options.length) {
            return null;
          }

          let opts = [chooseAnOption, ...options];
          if (type === 'dropdown') {
            opts = value
              ? [{ name: value, value }, ...options]
              : [chooseAnOption, ...options];
          }

          if (id === divideAfter) {
            return (
              <React.Fragment key={id}>
                <ValidatedDropDownField
                  id={id}
                  key={id}
                  label={label}
                  value={value}
                  onChange={onChange}
                  options={opts}
                  valid={validatedField}
                  validatedField={validatedField}
                  req={req}
                  isSubmitBtnClicked={isSubmitBtnClicked}
                  fullwidth={$fullwidth}
                  disabled={disabled}
                />
                <StyledDivider />
                <div
                  style={{
                    width: '100%',
                    paddingTop: '4px',
                  }}
                ></div>
              </React.Fragment>
            );
          }

          return (
            <ValidatedDropDownField
              id={id}
              key={id}
              label={label}
              value={value}
              onChange={onChange}
              options={opts}
              valid={validatedField}
              validatedField={validatedField}
              req={req}
              isSubmitBtnClicked={isSubmitBtnClicked}
              fullwidth={$fullwidth}
              disabled={disabled}
            />
          );
        }
        return (
          <ValidatedInputField
            id={id}
            key={id}
            type={type}
            label={label}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            validatedField={validatedField}
            fullwidth={$fullwidth}
            req={req}
            disabled={disabled}
            isSubmitBtnClicked={isSubmitBtnClicked}
            autocomplete={autocomplete}
          />
        );
      }
    );
  return <>{renderFields}</>;
};
